import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Schedule } from "@kiddocare-platform/portal-common/clinical";

export class ClinicalBookingService extends BaseService {

  public async SearchSlots(search: {
    idAccountPediatrician?: bigint;
    idAccountPatient?: bigint;
    startDate: string;
    endDate: string;
    onOffice?: boolean;
    onRemote?: boolean;
    idVisitType?: bigint;
  }): Promise<ResponseMessage<Array<Schedule>>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/booking/searchSlots`, search);
      return response.data;
    } catch (error: any) {
      this.log.error("SearchSlots", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async SearchSchedules(search: {
    idAccountPediatrician: bigint;
    startDate: string;
    endDate: string;
    idVisitType?: bigint;
  }): Promise<ResponseMessage<Array<Schedule>>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/booking/searchSchedules`, search);
      return response.data;
    } catch (error: any) {
      this.log.error("SearchSchedules", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}
